import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import BaseLayer from "../../core/BaseLayer";
export default class TileDebugLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'TileDebugLayer');
    _defineProperty(this, "zIndex", 10000);
    _defineProperty(this, "defaultSourceConfig", {
      data: [],
      options: {
        parser: {
          type: 'testTile'
        }
      }
    });
  }
  buildModels() {
    return _asyncToGenerator(function* () {
      return;
    })();
  }
}